import StreamChart from "../../components/admin/StreamChart";
import { useEffect, useState } from "react";
import { musicService } from "../../services";
import Spinner from "../../components/UI/Spinner";
import ErrorModal from "../../components/UI/Error";

const Card = ({ children }) => (
  <div className="bg-white p-4 shadow-md rounded-lg">{children}</div>
);

const ArtistDashboard = () => {
  const [userCardData, setUSerCardData] = useState(null);
  const [topStreamMusic, setTopStreamMusic] = useState(null);
  const [streamChartData, setStreamChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fectchAllData = async () => {
      try {
        setError(false);
        const [topStream, allMusic, streams, earnings] = await Promise.all([
          musicService.myTopStreamMusic(),
          musicService.getMyTotalMuic("me"),
          musicService.getMyTotalStreams("me"),
          musicService.getMyTotalEarnings("me"),
        ]);
        setTopStreamMusic(topStream);
        const topSong = topStream[0]?.title || null;

        const userCard = [
          { title: "🎶 All Music", detail: allMusic.all || 0 },
          { title: "🔥 Total Streams", detail: streams.totalStreams || 0 },
          { title: "🌟 Top Song", detail: topSong || "N/A" },
          { title: "💰 Royalties", detail: earnings.totalEarnings || 0 },
        ];

        const { boomplay, appleMusic, youtubeMusic, spotify, amazonMusic } =
          await musicService.getMyTotalStreamsByPlatforms("me");
        const streamChartData = [
          { key: "apm", platform: "Apple Music", streams: appleMusic || 0 },
          { key: "sfy", platform: "Spotify", streams: spotify || 0 },
          { key: "azm", platform: "Amazon Music", streams: amazonMusic || 0 },
          //{ key: "YTM", platform: "Youtube Music", streams: youtubeMusic || 0 },
          //{ key: "BMP", platform: "Boomplay", streams: boomplay || 0},
        ];
        setStreamChartData(streamChartData);
        setUSerCardData(userCard);
      } catch (error) {
        console.log(error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fectchAllData();
  }, []);
  if (loading)
    return (
      <div className="grid place-content-center h-[60vh]">
        <Spinner />
      </div>
    );
  if (error)
    return (
      <ErrorModal
        isOpen={error}
        onClose={() => setError(false)}
        title={"Error Fetching Data"}
        message={
          "There is error while trying to fetch the dashboard details. Please check your internet contivities and refresh this page to try again"
        }
      />
    );
  return (
    <div className="flex flex-col min-h-screen bg-gray-100 p-6">
      <h1 className="text-2xl font-bold mb-4">Welcome, Artist!</h1>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
        {userCardData &&
          userCardData.map((data, i) => (
            <Card key={i}>
              <div className="flex flex-wrap gap-2 align-center justify-center">
                <p className="text-center min-w-3/5">{data.title}</p>{" "}
                <p className="text-center"> {data.detail}</p>
              </div>
            </Card>
          ))}
      </div>

      <div className="mb-6">
        <Card>
          <StreamChart streamChartData={streamChartData} />
        </Card>
      </div>

      <Card>
        <h2 className="text-lg font-bold mb-2">Top Streamed Music</h2>
        {topStreamMusic?.length > 0 ? (
          <ul className="space-y-2">
            {topStreamMusic.map((song, i) => (
              <li key={i} className="flex justify-between border-b py-2">
                <span>{song.title}</span>
                <span>{song.totalStreams || 0} streams</span>
              </li>
            ))}
          </ul>
        ) : (
          <h1>You have no music</h1>
        )}
      </Card>
    </div>
  );
};

export default ArtistDashboard;
